<div class="min-h-screen h-full flex flex-col">
  <main
    class="p-4 w-full flex-1 min-h-0"
    [class.max-w-screen-xl]="!isDashboardRoute()"
    [class.mx-auto]="!isDashboardRoute()"
  >
    <router-outlet />
  </main>
</div>
